import FAQFullPage from "@/components/FAQFullPage";
import { homeFAQGroups } from "@/data/membershipsFAQData";

const FAQ = () => {
  return (
    <div className="bg-white pt-25 md:pt-50">
      <FAQFullPage groups={homeFAQGroups} />
    </div>
  );
};

export default FAQ;
